import { HorizontalLabelContainer } from 'components/TimeWindow';
import styled, { StyledProps } from 'styled-components/macro';

export type TableStylesProps = StyledProps<{}>;

export const Table = styled.div`
  table {
    border: 1px solid ${(props) => props.theme.colors.grayLight};
    width: 100%;

    thead {
      border-bottom: 1px solid ${(props) => props.theme.colors.grayLight};
      tr {
        th {
          border-right: 1px solid ${(props) => props.theme.colors.grayLight};
          height: 30px;
          color: #444;
          padding: 0 10px;
          background: #ededed;
          font-weight: bold;
          font-size: 12px;

          &:last-child {
            border: none;
          }

          button {
            border: none;
          }
        }
      }
    }

    tbody {
      tr {
        background-color: #fff;
        border-bottom: 1px solid #ced4da;

        &.total {
          background: #e8edf2;
          td {
            font-weight: 700;
          }
        }

        th {
          border-right: 1px solid ${(props) => props.theme.colors.grayLight};
          border-right: 1px solid ${(props) => props.theme.colors.grayLight};
          height: 30px;
          color: #444;
          padding: 0 10px;
          font-weight: bold;
          font-size: 12px;

          &:last-child {
            border: none;
          }
          &.center {
            text-align: center;
          }
        }

        td {
          height: 32px;
          color: #293845;
          font-size: 12px;
          font-weight: 400;
          padding: 0 10px;
          border-right: 1px solid #dfe7ed;

          &:last-child {
            border-bottom: none;
          }
        }
      }
    }
  }
`;

export const CenteredContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

export const WeightedHeader = styled.div`
  display: flex;
  flex-direction: row;
  ${HorizontalLabelContainer} {
    margin-right: 40px;
  }
`;

export const Loader = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 20px 0;
`;

export const RightAlignedContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: right;
`;
